mutation studentArchive($id: ID!, $tz: String) {
  studentArchive(id: $id) {
    id
    communicationCount
    first
    gradeLevel {
      id
      name
    }
    groups {
      id
      name
      teacher {
        id
        first
        last
      }
    }
    homeNumbers {
      id
      label
      formattedNumber
    }
    last
    mostRecentCommunication
    positivity
    archivedAt(tz: $tz)
    archivingTeacher {
      id
      first
      isCurrent
      last
    }
    deletedAt(tz: $tz)
    deletingTeacher {
      id
      first
      isCurrent
      last
    }
  }
}
